import { h } from 'preact'
import { memo } from 'preact/compat'
import translate from '@core/translate'
import withSearch from '@features/elastic/core/withSearch'

const FacetSelection = ({ onClick, text }) => (
	<div className="facet-selections__selection" onClick={onClick} role="button" tabIndex="-1">
		<span className="facet-selections__selection__text">{text}</span>

		<svg
			className="facet-selections__selection__icon"
			width="14"
			height="14"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.14905 3.3874L3.26256 3.26256C3.90578 2.61935 4.92513 2.58151 5.6126 3.14905L5.73744 3.26256L14 11.525L22.2626 3.26256C22.946 2.57915 24.054 2.57915 24.7374 3.26256C25.4209 3.94598 25.4209 5.05402 24.7374 5.73744L16.475 14L24.7374 22.2626C25.3807 22.9058 25.4185 23.9251 24.8509 24.6126L24.7374 24.7374C24.0942 25.3807 23.0749 25.4185 22.3874 24.8509L22.2626 24.7374L14 16.475L5.73744 24.7374C5.05402 25.4209 3.94598 25.4209 3.26256 24.7374C2.57915 24.054 2.57915 22.946 3.26256 22.2626L11.525 14L3.26256 5.73744C2.61935 5.09422 2.58151 4.07487 3.14905 3.3874L3.26256 3.26256L3.14905 3.3874Z"
				fill="#fff"
			/>
		</svg>
	</div>
)

const FacetSelections = ({ removeFacet, priceRange, setPriceRange, selectedOptions }) => {
	const hasFacets = selectedOptions && selectedOptions.length
	const hasPriceRange = priceRange && priceRange.length
	const count = (hasFacets ? selectedOptions.length : 0) + (hasPriceRange ? 1 : 0)

	const clearFilters = () => {
		selectedOptions.map(option => removeFacet(option.key, option.name))
		setPriceRange([])
	}

	return (
		<div className="facet-selections">
			<div className="facet-selections__title">
				<span>
					{translate('category.selectedfacets')} ({count})
				</span>

				<button type="button" onClick={() => clearFilters()}>
					Rensa alla
				</button>
			</div>

			<div className="facet-selections__list">
				{priceRange?.length > 0 && (
					<FacetSelection
						onClick={() => setPriceRange([])}
						text={`${translate('search.pricerange')}: ${`${priceRange[0]} - ${priceRange[1]}`}`}
					/>
				)}

				{selectedOptions.map(option => (
					<FacetSelection
						key={option.url}
						text={`${option.facet}: ${option.name}`}
						onClick={() => removeFacet(option.key, option.name)}
					/>
				))}
			</div>
		</div>
	)
}

export default withSearch(({ addFacet, removeFacet, priceRange, setPriceRange, facets }) => ({
	addFacet,
	removeFacet,
	priceRange,
	setPriceRange,
	facets,
}))(FacetSelections)
